module.exports = __webpack_public_path__ + "assets/b36.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b36.png
// module id = 623
// module chunks = 0